import { connect } from "react-redux";
import SiteInspectionMaterial from "./siteInspectionMaterial";
import { bindActionCreators } from "redux";
import {
  getSiteInspect,
  getSiteInspectSolution,
  postSolution,
  getLocationApprovalPending,
  getPocBySiteId,
  postSendReportMail,
  getCheckLocation
} from "services/redux/installation/siteInspection/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";
import {
  postReportDetails,
  generateReport,
} from "services/redux/installation/materialRequisition/action";
import {
  getInventory,
  postGateInventory,
} from "services/redux/installation/inventoryCheckList/action";
import { getMateriaById } from "services/redux/sales/postSales/corporate/action";
import {getSiteData, calculateDistance, getDistanceData} from "../../../services/redux/DistanceCalculator/action";

const mapStateToProps = (state) => ({
  siteData: state.siteInspectionReducer.siteDataSolution,
  locationApproval: state.siteInspectionReducer.locationApproval,
  pocListBySiteId: state.siteInspectionReducer.pocListBySiteId,
  locationCheck : state.siteInspectionReducer.locationCheck,
  userProfile : state.loginReducer.userProfile,
  inventoryData: state.inventoryReducer.inventoryData,
  getMaterial: state.coporatePostLeadReducer.getMaterial,
  siteDetails: state.leadDataReducer.siteData,
  engDistanceData: state.leadDataReducer.engDistanceData,
  distanceDetails: state.leadDataReducer.distanceDetails,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getInventory,
      postSolution,
      getMateriaById,
      postGateInventory,
      getSiteInspect,
      getSiteInspectSolution,
      documentUploadUrl,
      postReportDetails,
      generateReport,
      getLocationApprovalPending,
      getPocBySiteId,
      postSendReportMail,
      getCheckLocation,
      getSiteData,
      calculateDistance,
      getDistanceData
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SiteInspectionMaterial);
